import React, { useState } from 'react'
import PrivacyPolicyPage from './PrivacyPolicyPage'
import TermsAndConditionPage from './TermsAndConditionPage';

export default function PrivacyPolicyMain() {
    const [activeTab, setActiveTab] = useState("privacy_policy");

    return (
        <>
            <div className="graph-btns tabs">
                <button className={activeTab === 'privacy_policy' ? 'active' : ''} onClick={() => setActiveTab("privacy_policy")}>Privacy Policy</button>
                <button className={activeTab === 'terms_contions' ? 'active' : ''} onClick={() => setActiveTab("terms_contions")}>Terms & Conditions</button>
            </div>

            <div className="chart-blk mt-2">
         
            {activeTab === "privacy_policy" && <PrivacyPolicyPage/>}
            {activeTab === "terms_contions" && <TermsAndConditionPage />}
         


          </div>
            
        </>
    )
}
